import { forwardRef, PropsWithChildren } from 'react';

import styles from '../../m50ShopTheLook.module.css';

export const TextMediaOffsetContent = forwardRef<HTMLDivElement, PropsWithChildren<unknown>>(({ children }, ref) => (
	<div className={styles.offsetContent}>
		<div
			className={styles.offsetContentInner}
			ref={ref}
		>
			{children}
		</div>
	</div>
));
